<template>
  <div>
    <h1>Resend Invitation</h1>
    <p v-if="this.$route.query.email">Psst, do you need a new password? I just send it at <b>{{fixEmail(this.$route.query.email)}}</b>. I won't tell Janosch, I swear!</p>
    <div v-else>
      To resend your Invitation Code type in your Email:
      <v-row>
        <v-col
          cols="6"
          sm="6"
          md="3"
        >
          <v-text-field v-model="email" label="Email"></v-text-field>
          <v-btn v-if="!loading" :disabled="!emailIsValid || done" @click="resendInvitation(email)">Resend Invitation</v-btn>
          <v-btn v-if="loading"><v-progress-circular indeterminate color="primary"></v-progress-circular></v-btn>
          <p v-if="done"><v-icon color="green darken-2">mdi-checkbox-marked-circle</v-icon> The email has been sent. Please check your inbox.</p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>


import axios from 'axios';

export default {
  name: 'ResendInvitation',
  data: () => ({
    email: '',
    loading: false,
    done: false
  }),
  created() {
    if (this.$route.query.email) {
      this.resendInvitation(this.$route.query.email);
    }
  },
  computed:{
      emailIsValid(){
          const regex = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/;
          return regex.test(this.email);
      }
  },
  methods: {
    fixEmail(email){
      return email.replace(" ", "+");
    },
    resendInvitation(email){
      this.loading = true;
      axios({
        url: 'users/0/resend-invitation-code',
        method: 'PUT',
        data: {
          email: this.fixEmail(email)
        },
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(() => {
        this.done = true;
        this.loading = false;
      })
    }
  }
};
</script>
